import {useState} from "react";
import {Popover} from '@material-ui/core';
import React from 'react';
import FeatureItem from './FeatureItem';
import {useWelcomeStyle} from '../styles/WelcomeStyle';
import {Constants} from "../constants/Constants";

export default function WhiteFeaturesPopUpView(props: any) {

    const classes = useWelcomeStyle();
    const [popUpAnchor, setPopupAnchor] = useState<HTMLElement | null>(props.anchor);
    const [open, setOpen] = useState(Boolean(popUpAnchor));

    const handlePopupClose = () => {
        setPopupAnchor(null);
        setOpen(false);
    }

    return (
        <Popover
            id="mouse-over-popover"
            open={open}
            className={classes.popover}
            onClose={handlePopupClose}
            anchorEl={popUpAnchor}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}>
            <div style={{display: 'flex', flexDirection: 'column'}}>
                <FeatureItem handler={props.handler} title_color="black" description_color="grey"
                             title="Win FREE BTC"
                             description={`Come back every <b style='color:black;'>1hr</b> to get FREE Coins`}/>
                <FeatureItem handler={props.handler} title_color="black" description_color="grey" title="Multiply BTC"
                             description={`Multiply your Bitcoins in seconds by playing our simple <span style="color:black;font-weight:600">${Constants.MULTIPLY_BTC_GAME} Game</span>`}/>
            </div>
        </Popover>
    );

}